/**
 * Test IDs for QA automation.
 */
export const testIds = {
  locationDrivenShipmentFormPrevious: "location-driven-shipment-form-previous",
  locationDrivenShipmentFormSaving: "location-driven-shipment-form-saving",
  locationDrivenShipmentFormNextOrSubmit: "location-driven-shipment-form-next-or-submit",
} as const;
